import React, { useState } from 'react'
import { Stack } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/free-regular-svg-icons'
import { faCircle as faCircleSolid } from '@fortawesome/free-solid-svg-icons'
import { Button } from '/src/components/common'

import './tabs_list.scss'

const getActiveItem = (items, active) => {
  return items.filter(item => item.id === active).pop()
}

const ItemIcon = ({ active }) => {
  if (active) {
    return <FontAwesomeIcon icon={faCircleSolid} />
  }

  return <FontAwesomeIcon icon={faCircle} />
}

export const TabsListInline = ({ items, Footer, defaultActive = 1 }) => {
  const [active, setActive] = useState(defaultActive)
  const { Content } = getActiveItem(items, active)

  const onClickHandler = (value) => {
    setActive(value)
  }

  return (
    <div className="tabs-list-inline">
      <Stack className="tabs-list" direction="horizontal" gap={0}>
        {items.map(({ id, label }) => {
          let itemClasses = ['tabs-list-item']
          if (id === active) {
            itemClasses.push('active')
          }

          return <Button key={id} onClick={() => onClickHandler(id)} className={itemClasses.join(' ')}>
            <ItemIcon active={id === active} />
            {label}
          </Button>
        })}
      </Stack>

      <div className="tabs-list-content">
        <Content />
      </div>

      {Footer && (
        <div className="tabs-list-footer">
          <Footer />
        </div>
      )}
    </div>
  )
}
